import React, { useState } from 'react';

export default function BrandLogo({ name, logo, className = '' }) {
  const [error, setError] = useState(false);
  if (error || !logo) {
    return (
      <div className={`flex items-center justify-center text-slate-500 font-semibold whitespace-nowrap ${className}`}>{name}</div>
    );
  }
  return (
    <img
      src={logo}
      alt={name}
      title={name}
      onError={() => setError(true)}
      className={`object-contain ${className}`}
    />
  );
}
